import { TEST_LOCATORS } from '@src/constants/test-locators'
import { QUINCE_BOT_LOCATORS } from '@src/quince-site-common/src/constants/quinceBot'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { ProductCTAConstants } from './constants'
import { ProductDisplayButton } from './product-display-button'
import { ProductDisplayText } from './product-display-text'
import { RenderErrorMessage } from './productCTA'
import styles from './productCTA.module.scss'
import { ProductWaitlistCTAType } from './types'

export const ProductWaitlistCTA = (props: ProductWaitlistCTAType) => {
  const { t } = useTranslation('common')
  const {
    selectedVariantPurchaseInfo,
    isCurrentProductOptionLeavingSoon,
    isBuyNowPdp,
    isPostOrderFlow,
    isQuickATCForMobile,
    isAddToCartInProgress,
    addToCartRef,
    isBuyNowInProgress,
    isKeyboardVisibleForQuickATCForMobile,
    trackIsVisibleWaitlistRef,
    setEmail,
    setIsKeyboardVisibleForQuickATCForMobile,
    handleClick,
    errorMessage,
  } = props

  if (isPostOrderFlow) {
    return (
      <ProductDisplayButton onClick={() => undefined} disabled={true} className="width--full pointer-events-none">
        {ProductCTAConstants.OUT_OF_STOCK}
      </ProductDisplayButton>
    )
  }

  return isCurrentProductOptionLeavingSoon ? (
    <div className={styles.buttonWrapper}>
      <div className={styles.leavingSoon__outOfStock}>{ProductCTAConstants.ITEM_NO_LONGER_AVAILABLE}</div>
      {isBuyNowPdp ? (
        <ProductDisplayButton
          onClick={handleClick}
          showLoader={isAddToCartInProgress}
          selectorKey={QUINCE_BOT_LOCATORS.PDP.ADD_TO_CART}
          buttonRef={addToCartRef}
          disabled={true}
          className={`width--full ${isBuyNowInProgress ? 'pointer-events-none' : ''}`}
        >
          {ProductCTAConstants.ADD_TO_CART}
        </ProductDisplayButton>
      ) : (
        <ProductDisplayButton onClick={handleClick} className={styles.waitlisted}>
          {ProductCTAConstants.SHOP_SIMILAR}
        </ProductDisplayButton>
      )}
    </div>
  ) : (
    <div data-testid={TEST_LOCATORS.PRODUCT_CTA} ref={trackIsVisibleWaitlistRef} className={styles.buttonWrapper}>
      <ProductDisplayText
        date={selectedVariantPurchaseInfo?.backInStockDate}
        className={styles.waitListed__text}
        isQuickATCForMobile={isQuickATCForMobile}
      />
      {!selectedVariantPurchaseInfo?.hasJoinedWaitList && !AuthUtil.isLoggedIn() && (
        <input
          onChange={e => setEmail?.(e.target.value)}
          onFocus={() => setIsKeyboardVisibleForQuickATCForMobile?.(true)}
          onBlur={() => setIsKeyboardVisibleForQuickATCForMobile?.(false)}
          className={classNames(styles.waitlistInput, isQuickATCForMobile && styles.waitlistInput__quickATC)}
          placeholder={isQuickATCForMobile ? t('enter_your_email_address') : t('your_email_address')}
          type="email"
        />
      )}
      {errorMessage && <RenderErrorMessage errorMessage={errorMessage} isQuickATCForMobile={isQuickATCForMobile} />}

      {isQuickATCForMobile ? (
        !isKeyboardVisibleForQuickATCForMobile && (
          <div className={styles.quickATCWrapper}>
            {selectedVariantPurchaseInfo?.hasJoinedWaitList ? (
              <ProductDisplayButton onClick={handleClick} className={styles.waitlisted}>
                {ProductCTAConstants.WAITLISTED}
              </ProductDisplayButton>
            ) : (
              <ProductDisplayButton onClick={handleClick}>{ProductCTAConstants.JOIN_WAITLIST}</ProductDisplayButton>
            )}
          </div>
        )
      ) : selectedVariantPurchaseInfo?.hasJoinedWaitList ? (
        <ProductDisplayButton onClick={handleClick} className={styles.waitlisted}>
          {ProductCTAConstants.WAITLISTED}
        </ProductDisplayButton>
      ) : (
        <ProductDisplayButton onClick={handleClick}>{ProductCTAConstants.JOIN_WAITLIST}</ProductDisplayButton>
      )}
    </div>
  )
}
